import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function IntegratedHumanPractices() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Human Practices
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Integrated Human Practices
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Integrated Human Practices
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("IHP-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Overview
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("IHP-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Brainstorming
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("IHP-3")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Idea Development
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("IHP-4")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Societal Benefits
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("IHP-5")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Ethics
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("IHP-6")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Feedback Integration
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="IHP-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Overview
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Have you ever considered how the shimmer effect in cosmetic products is produced?
                                It may already be due to a vegan ingredient, but is that enough to say it is
                                sustainable? Not only the source of that ingredient must be sustainable, but also
                                its production process must be ethical. Our Bioglimmer project provides an innovative
                                solution for both aspects! The cosmetic business is constantly evolving to meet the
                                changing needs of customers. There has been a notable increase in awareness about the
                                importance of sustainable cosmetic ingredients, largely due to educational
                                initiatives. However, there is still more to be done to raise public awareness about
                                the supply chain of those ingredients, which is often still not completely
                                transparent. In this context of ethical sourcing uncertainty, our project BioGlimmer
                                aims to offer a vegan and ethically produced alternative to provide the shimmer
                                effect in cosmetic products.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="IHP-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Brainstorming
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                The panel discussion with KTH and KI expert professors on the application of
                                synthetic biology in different fields provided valuable feedback on all the
                                potential research proposals that emerged during our February and March brainstorming
                                sessions. The professors assisted us in focusing on the implications of our ideas,
                                particularly in regard to environmental risk and societal acceptance. Furthermore,
                                the results of a survey (google form qr code hanged in Universities buildings)
                                conducted among students at Stockholm universities regarding potential applications
                                of system biology influenced the final project selection. The incorporation of these
                                two crucial feedback loops has culminated in the development of our BioGlimmer
                                project, which entails the synthesis of guanine crystals for cosmetic applications
                                in a vegan and ethical manner.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="IHP-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Idea Development
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Synthetic biology is able to help us in the development of cosmetic ingredients that
                                are both vegan and ethically produced. Thus, by applying the iGEM engineering cycle,
                                after learning about it through the panel discussion, we have focused on designing
                                our experimental project, building the necessary construct through dry lab modelling,
                                and testing the wet lab results until we will obtain our exciting guanine crystals!
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="IHP-4" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Societal Benefits
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Market research indicates that consumers prefer products with glittery and/or
                                shimmery effects in the majority of cosmetic categories. While the use of vegan
                                products is often clearly visible on the packaging, as a response to consumer
                                demand, the supply chain of cosmetics ingredients is not as transparent. This
                                lack of transparency is often linked to the production of unethical products.
                                Our mission here is to raise awareness about the importance of a transparent
                                supply chain, especially when it comes to respecting human rights and planet resources.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="IHP-5" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Ethics
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                The production of the shimmer effect in cosmetic products raises questions about the
                                sustainability of the process. While the use of a vegan ingredient may be a positive
                                step, it is not sufficient to guarantee that the product is sustainable. In addition
                                to the source of the ingredient, it would be beneficial to consider the production
                                process in order to respect human rights. By applying synthetic biology, it is
                                possible to produce guanine crystals without contributing to the overfishing problem,
                                and with the assurance that the supply chain does not involve any disrespect of
                                human rights, as is the case with child labour in the mines for mica (another
                                mineral substitute of guanine crystal from fishing).
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="IHP-6" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Feedback Integration
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                In order to assess the social impact of our project, we have engaged with a number
                                of external stakeholders, whose input has been instrumental in the completion of
                                our research project in synthetic biology:
                            </div>
                            <div className="mt-5">
                                The panel discussion with KTH and KI professors, experts in the field of synthetic
                                biology, provided an invaluable opportunity to explore the potential of synthetic
                                biology in addressing societal needs. The discussion encompassed crucial aspects
                                such as environmental risk and societal acceptance of our potential product.
                            </div>
                            <div className="mt-5">
                                1. The survey conducted among Stockholm university students on the potential of
                                system biology to address societal challenges was highly informative. It offered
                                insights into the perceptions of a broader section of society regarding the issues
                                that require attention.
                            </div>
                            <div className="mt-5">
                                2. By reaching out to cosmetic companies in order to establish a dialogue and discuss
                                the potential of our vegan and ethically obtained mica alternative, we have gained
                                invaluable insight into the inner workings of the cosmetic business. Despite the
                                majority of these companies expressing opposition to the use of GMO-derived
                                ingredients in their products, they were pleased to see young students engaged
                                in attempting to resolve cosmetic ingredients' ethical issues by providing a valuable
                                alternative. This suggests to us that there is still a need for better regulations
                                and better societal awareness regarding the use of GMO and their derivatives in
                                cosmetic products. For this reason, we decided to create two educational games
                                about synthetic biology (see Education section).
                            </div>
                            <div className="mt-5">
                                3. We have been extremely grateful to receive feedback from juries after presenting
                                our project at a number of events, including the Biobrick workshop in Copenhagen, the
                                Madrid conference, the Bielefeld conference, the Swedish conference in Lund, and the
                                Nordic iGEM conference in Turku. This invaluable input has helped us to gain a deeper
                                understanding of how to more effectively communicate the value of our product to
                                potential customers.
                            </div>
                            <div className="mt-5">
                                4. By participating in numerous career fairs and welcome events for new students, we
                                have had the opportunity to showcase our current project as an example of the
                                research opportunities available to those who join the iGEM Stockholm team. We were
                                gratified to observe that professors and new students appeared inspired by our
                                engagement. We are confident that our efforts have succeeded in raising awareness
                                of the synthetic biology field and its potential.
                            </div>
                            <div className="mt-5">
                                5. A discussion was held at St. Martins Gymnasium (high school make-up artist
                                programme) between students and teachers on the ethical ingredients in cosmetic
                                products. It was an invaluable opportunity for all involved to gain additional
                                insights, particularly from a seller's perspective regarding anticipated consumer
                                requests. This helped to create a more comprehensive picture of the loop between
                                producers, sellers and consumers.
                            </div>
                        </div>
                    </div>

                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}